<template>
  <vs-button
    :class="{ 'button': true, [size]: true }"
    v-bind="$attrs"
    :style="bgColor ? { backgroundColor: `${bgColor} !important` } : null"
    icon-pack="feather"
    :icon="$attrs.icon ? `icon-${$attrs.icon}` : ''"
    v-on="$listeners"
  >
    <slot></slot>
  </vs-button>
</template>

<script>
export const secondary = {
  render(h) {
    return h('vs-button', {
      'class': {
        'button': true,
        [this.size || '']: true
      },
      'attrs': {
        ...this.$attrs,
        'icon-pack': 'feather',
        'icon': `icon-${this.$attrs.icon}`
      },
      'props': {
        'type': 'border'
      },
      'on': this.$listeners
    }, [
      this.$slots.default
    ])
  },
}

export const flat = {
  render(h) {
    return h('vs-button', {
      'class': {
        'button': true,
        'flat': true,
        [this.size || '']: true,
        'dark': this.$attrs.dark !== undefined
      },
      'attrs': {
        ...this.$attrs,
        'icon-pack': 'feather',
        'icon': `icon-${this.$attrs.icon}`
      },
      'props': {
        'type': 'flat',
        'color': this.$attrs.dark !== undefined ? 'rgb(var(--vs-lunar-darkest))' : `${this.$attrs.color}` ?? 'primary'
      },
      'on': this.$listeners
    }, [
      this.$slots.default
    ])
  }
}
export default {
  name: "primary-button",
  props: {
    size: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss">
.button {
  padding: 11px 22.5px !important;
  border-radius: 8px;
  height: 40px;
  font-weight: 500;
  width: 100%;

  @screen md {
    width: unset;
  }

  &.vs-button-primary.vs-button-filled:hover {
    box-shadow: 0 8px 25px -8px var(--primary) !important;
  }

  &.includeIconOnly {
    padding: 0.5rem 1rem !important;
    width: 40px !important;
    height: 40px !important;

    .vs-button--icon {
      font-size: 18px;
    }
  }

  .vs-button--text, .vs-button--icon {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    & i {
      margin-right: 8px;
    }
  }

  &.small {
    padding: 0.25rem 0.75rem !important;
    height: 24px;
    border-radius: 6px;

    .vs-button--text, .vs-button--icon {
      font-size: 0.75rem;
    }

    &.includeIconOnly {
      width: 24px !important;
      height: 24px !important;

      .vs-button--icon {
        font-size: 0.75rem;
      }
    }
  }

  &.large {
    padding: 14px 19.5px !important;
    font-size: 16px;
    height: 48px;

    &.includeIconOnly {
      width: 48px !important;
      height: 48px !important;
    }
  }

  &.flat {

    &.dark {
      &:hover {
        background-color: var(--lunar) !important;
      }

      .vs-button--text, .vs-button--icon {
        color: var(--onyx) !important;
      }
    }
  }
}
</style>
